// GLobals
import { useTranslation } from 'react-i18next';

// Components
import { FormItem } from '@/components';
import { Input } from '@/ui';

// Helpers
import { BrandsFormFields } from '../../helpers/types';

const BrandSeo = () => {
  const { t } = useTranslation(['common']);

  return (
    <>
      <FormItem label={t('update_page_form_seo_title')} name={[BrandsFormFields.SEO, 'title']}>
        <Input />
      </FormItem>
      <FormItem label={t('update_page_form_seo_description')} name={[BrandsFormFields.SEO, 'description']}>
        <Input />
      </FormItem>
      <FormItem label={t('update_page_form_seo_keywords')} name={[BrandsFormFields.SEO, 'keywords']}>
        <Input />
      </FormItem>
    </>
  );
};

export default BrandSeo;
